export default __webpack_public_path__ + "static/media/orange-task-checkbox.ec34617d.svg";